import React from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';

function Spinner(props) {
	return (
		<FontAwesomeIcon
			icon={faSpinnerThird}
			spin
			className={classnames('Spinner', {
				...props.className ? {
					[props.className]: true
				} : {}
			})}
		/>
	);
}

export default Spinner;
